/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_NavInputs */

const en_help_nav = /** @type {(inputs: Help_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

const pl_help_nav = /** @type {(inputs: Help_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomoc`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {Help_NavInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_nav = /** @type {((inputs?: Help_NavInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_NavInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_nav(inputs)
	return en_help_nav(inputs)
});